import React from "react";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import { getTranslateByKey } from "@/main/services/utils";
import { IStatesDataDeliveryLogistic } from "../types";
import { IconButton, TableCell } from "@mui/material";
import Close from "@mui/icons-material/Close";
import * as S from "./styles";

interface IGridLogisticProps extends IStatesDataDeliveryLogistic {
	idsErrorDataDeliverLogistic: string[];
}

function GridLogistic({
	dataDeliverLogistic,
	idsErrorDataDeliverLogistic,
	setDataDeliverLogistic,
}: IGridLogisticProps) {
	function handleDeleteRow(e: React.MouseEvent<HTMLButtonElement, MouseEvent>, id: string) {
		e.preventDefault();
		e.stopPropagation();
		setDataDeliverLogistic(dataDeliverLogistic.filter((item) => item.id !== id));
	}

	const rowHeaders = [
		getTranslateByKey("information.deliveryType"),
		getTranslateByKey("information.initialZipCode"),
		getTranslateByKey("information.finalZipCode"),
		getTranslateByKey("information.daysDeliveryPart"),
		"",
	];
	const isEmptyData = dataDeliverLogistic.length === 0;
	return (
		<S.Container>
			<BoxGrid id="id-registerSupplier-grid-logistics" rowHeaders={isEmptyData ? [] : rowHeaders}>
				{!isEmptyData &&
					dataDeliverLogistic.map((item) => (
						<S.CustomTableRow key={item.id} $hasError={idsErrorDataDeliverLogistic.includes(item.id)}>
							<TableCell>{item.deliveryType}</TableCell>
							<TableCell>{item.initialZipCode}</TableCell>
							<TableCell>{item.finalZipCode}</TableCell>
							<TableCell>{item.daysDelivery}</TableCell>
							<TableCell>
								<S.ColumnActions>
									<IconButton
										id={`id-registerSupplier-btn-delete-${item.id}`}
										onClick={(e) => handleDeleteRow(e, item.id)}
									>
										<Close />
									</IconButton>
								</S.ColumnActions>
							</TableCell>
						</S.CustomTableRow>
					))}
			</BoxGrid>
		</S.Container>
	);
}

export default GridLogistic;
